import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { Card, CardBody } from "../../components/card/card";
import { auth } from "../../api";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
function LoginByPass() {
  const navigate = useNavigate();
  const { loginByPass } = useAuth();
  const { selectedApp, handleChangeApp } = useDashboardContext();
  const context = useContext(AppSettings);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [activated, setActivated] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (token) {
      handleSubmit();
    }
  }, [token]);

  async function handleSubmit() {
    if (!token) {
      toast.error("Invalid token");
    }

    try {
      setLoading(true);
      if (!token) {
        toast.error("Token not available");
        setLoading(false);
        return;
      }
      const [status, message, data] = await loginByPass(token);
      //console.log({ status, message });
      if (!status) {
        toast.error(message);
        setLoading(false);
      } else {
        handleChangeApp(data.service?.service_id);
        setTimeout(() => {
          if (data.service?.service_id === "CMMS") {
            window.location.href = "/work-order/list";
          } else {
            window.location.href = "/machine-health";
          }
        }, 150);
      }
    } catch (e) {
      navigate("/machine-health");
      toast.error(e);
      setLoading(false);
    }

    setLoading(false);
  }
  return (
    <div className="login">
      <LoadingIndicator open={loading} />
      <div className="login-content">
        <img
          src="/assets/img/logo_white.svg"
          style={{ width: "100%" }}
          alt=""
        />
        {activated === "invalid" && (
          <div style={{ marginTop: "20px" }}>
            <Card>
              <CardBody>
                <div style={{ textAlign: "center" }}>Invalid Token</div>
              </CardBody>
            </Card>
          </div>
        )}

        {activated === "success" && (
          <div style={{ marginTop: "20px" }}>
            <Card>
              <CardBody>
                <div style={{ textAlign: "center" }}>Login Verified!</div>
              </CardBody>
            </Card>
            <div style={{ marginTop: "10px", textAlign: "center" }}>
              <a
                type="submit"
                href={"/login"}
                style={{ margin: "auto" }}
                className="btn btn-outline-theme btn-lg d-block w-50 fw-500 mb-3"
              >
                Sign In
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginByPass;
